import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { shareClose } from '../store/actions'
import { getShareData, isShareOpen } from '../store/selectors'

import ModalShare from './ModalShare'

const ShareContainer = () => {
  const dispatch = useDispatch()
  const data = useSelector(getShareData)
  const isOpen = useSelector(isShareOpen)

  const handleClose = useCallback(() => {
    dispatch(shareClose())
  }, [dispatch])

  return (
    <ModalShare onClose={handleClose} isOpen={isOpen} {...data} />
  )
}

export default ShareContainer
